import { AppNS, Dcra } from 'app';

import { InspectionsState } from './inspections';

export function checkReportValid(state: InspectionsState): string[] {
  const report = state.currentInspection;
  if (!report) {
    state.isReportValid = false;
    return [];
  }
  let validationErrors: Array<string> = [];

  if (!report.checkInAt) {
    validationErrors.push('Please Check In');
  }
  if (!report.checkOutAt) {
    validationErrors.push('Please Check Out');
  }

  // all inspections items must have been set to other status than 'scheduled'
  if (
    report?.permits?.length &&
    report.permits.find((permit) =>
      permit.inspections.find((item: AppNS.Inspection) => item.status.toLowerCase() === 'scheduled')
    ) !== undefined
  ) {
    validationErrors.push(`Please set status for all inspections (Cannot be 'Scheduled').`);
  }

  if (!report.inspectionQuestionnaire) {
    validationErrors.push('Please fill in "ON SITE DOCUMENTS" section');
  }

  if (!checkInspectionChecklist(report)) {
    validationErrors.push('Please fill in "INSPECTION CHECKLIST" section');
  }

  if (
    (!report.inspectionQuestionnaire || !Object.values(report.inspectionQuestionnaire).includes('no')) &&
    !checkEventsInspectionsDocumentsValid(report?.permits?.map((p: AppNS.Permit) => p.inspections || []).flat(1))
  ) {
    validationErrors.push(
      'Photos of the site are required to be uploaded for each inspection type prior to submitting the inspection report.'
    );
  }

  state.reportValidErrors = validationErrors;
  state.isReportValid = validationErrors.length ? false : true;

  return validationErrors;
}

function checkEventsInspectionsDocumentsValid(eventInspections: Array<AppNS.Inspection>): boolean {
  eventInspections?.forEach((inspection) => {
    if (
      !['Cancelled', 'Void'].includes(inspection.status) &&
      (!inspection.files || inspection.files.filter((d) => !d.isRemoved).length === 0)
    ) {
      return false;
    }
  });
  return true;
}

function checkInspectionChecklist(report: Dcra.Inspection): boolean {
  let result = true;

  if (
    (!report.inspectionChecklist || Object.values(report.inspectionChecklist).length === 0) &&
    report?.permits?.find((permit) =>
      permit.inspections.find((item: AppNS.Inspection) => ['Stop Work Order', 'Citation'].includes(item.status))
    ) !== undefined
  ) {
    result = false;
  }

  return result;
}
